$w.onReady(function () {

var style1 = "height:" + 86.57 + "vh" + ";" + "color:" + "transparent"; //change 86.57 to whatever you calc
$w("#vh").html = "<" + "h1" + " style=" + style1 + ">" + $w("#vh").text + "</" + "h1" + ">";
});

import wixSite from 'wix-site';
$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick(event) {
	$w('#preloader').show();
	waitForLoading();
}

function waitForLoading() {
	setTimeout(() => {
		$w('#preloader').hide();
	}, 1500);
}

let response = wixSite.prefetchPageResources({
	"lightboxes": ["First Box", "Second Box"],
	"pages": ["/first-page", "/second-page"]
});